import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { useRecoilValue } from 'recoil';

import styles from '../../theme/styles';
import { appointmentForState } from '../../common/recoil/atom/AppointmentForAtom';
import useFocusHeadingOnScreenChange from '../../hooks/useFocusHeadingOnScreenChange';

const EventHeader = (props) => {
  const { classes, headerText, subHeaderText, descriptionText } = props;
  const apptFor = useRecoilValue(appointmentForState);
  const titleRef = useRef(null);

  const fetchTitle = (fromText) => {
    if (typeof fromText === 'undefined') return false;
    else if (typeof fromText === 'string') return fromText;
    else if (typeof fromText[apptFor] === 'undefined') return '';
    else return fromText[apptFor];
  };

  const useTitle = fetchTitle(headerText);
  const useSubTitle = fetchTitle(subHeaderText);
  const useDescription = fetchTitle(descriptionText);

  useFocusHeadingOnScreenChange(titleRef);

  // The question is the page's h1; it keeps the h2 look and the sub/description are h2s.
  return (
    <div className={classes.headerEventContainer}>
      <Typography
        variant="h2"
        component="h1"
        tabIndex={-1}
        ref={titleRef}
        className={classes.headerEventTitle}
      >
        {useTitle}
      </Typography>
      {useSubTitle && (
        <Typography
          variant="h3"
          component="h2"
          className={classes.headerEventSubTitleText}
        >
          <span dangerouslySetInnerHTML={{ __html: useSubTitle }} />
        </Typography>
      )}
      {useDescription && (
        <Typography
          variant="h3"
          component="h2"
          className={classes.headerEventDescriptionText}
        >
          <span dangerouslySetInnerHTML={{ __html: useDescription }} />
        </Typography>
      )}
    </div>
  );
};

EventHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subHeaderText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  descriptionText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default withStyles(styles)(EventHeader);
